import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import {Url} from '../common';
import { NavBarService } from './layout/services/navbar.service';
import html2canvas from 'html2canvas';
import { Ticket } from './pages/default/ticket/models/ticket.model';
import {environment} from '../../environments/environment';

@Component({
    selector: "cms",
    templateUrl: "./cms.component.html",
    styleUrls: ['./cms.css']

})
export class CmsComponent implements OnInit {

    bug = false;
    isCollapsed$:Observable<boolean>=null;
    isCollapseKnowledge$:Observable<boolean>=null;
    url=Url;

    constructor(private navBarService: NavBarService) {

    }

    ngOnInit() {
      this.isCollapsed$= this.navBarService.isCollapsed$;
      this.isCollapseKnowledge$= this.navBarService.isCollapseKnowledge$;
    }

    openBug()
    {
      this.bug = !this.bug;
    }

}
